<template>
    <div class="compare-vehicle-menu">
        <dk-popper
            ref="popper"
            :has-arrow="false"
            :popper-opts="popperOptions"
            :max-width="'auto'"
            :max-height="'auto'"
            :disabled="disabled"
            selectable
            @change="selectItem"
            @re-clicked="selectItem"
        >
            <template slot="reference">
                <dk-button
                    variant="ghost"
                    class="compare-vehicle-menu__button tw-absolute tw-top-2 tw-right-2 !tw-text-slate-400 hover:!tw-text-basic"
                >
                    <dk-icon name="ds-dots-vertical" size="xs" class="lg:!tw-hidden" />
                    <dk-icon name="ds-dots-vertical" size="s" class="!tw-hidden lg:!tw-block" />
                </dk-button>
            </template>

            <dk-popper-item :item="{ action: actions.edit }">
                <dk-icon name="ds-edit-filled" size="xs" /> {{ $t('compare.edit') }}
            </dk-popper-item>
            <dk-popper-item v-if="url" :href="url">
                <dk-icon name="ds-road-tax" size="xs" /> {{ $t('compare.more-specs') }}
            </dk-popper-item>
            <dk-popper-item v-if="canRequestQuote" :item="{ action: actions.quote }">
                <dk-icon name="ds-tag-price-filled" size="xs" /> {{ $t('compare.request-a-quote') }}
            </dk-popper-item>
            <dk-popper-item :item="{ action: actions.delete }">
                <dk-icon name="ds-close-filled" size="xs" /> {{ $t('compare.delete') }}
            </dk-popper-item>
        </dk-popper>
    </div>
</template>
<script>
export const ACTIONS = {
    edit: 'edit',
    quote: 'quote',
    delete: 'delete',
    configure: 'configure',
};

/**
 * Compare vehicle menu
 *
 * @version 4.0.0
 * @example ./examples/CompareVehicleMenu.md
 */
export default {
    name: 'CompareVehicleMenu',
    components: {
        DkPopper: () => ({
            component: import(/* webpackChunkName: "DkPopper-vue" */ '@v4/common/components/molecules/DkPopper.vue'),
        }),
        DkPopperItem: () => ({
            component: import(
                /* webpackChunkName: "DkPopperItem-vue" */ '@v4/common/components/atoms/DkPopperItem.vue'
            ),
        }),
        DkIcon: () => ({
            component: import(/* webpackChunkName: "DkIcon-vue" */ '@v4/common/components/atoms/DkIcon.vue'),
        }),
        DkButton: () => ({
            component: import(/* webpackChunkName: "DkButton-vue" */ '@v4/common/components/atoms/DkButton.vue'),
        }),
    },
    props: {
        /**
         * Vehicle detail page URL
         */
        url: {
            type: String,
            default: null,
        },
        /**
         * Whether or not disabled
         */
        disabled: {
            type: Boolean,
            default: false,
        },
        /**
         * Whether the request quote button is visible
         */
        canRequestQuote: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            popperOptions: {
                placement: 'bottom-end',
            },
            actions: ACTIONS,
        };
    },
    methods: {
        selectItem({ item }) {
            this.$emit('selection', item);
        },
    },
};
</script>
